'use client'

import classNames from 'classnames'
import { map } from 'lodash-es'
import useAgentListingsContext from '../context'

export default function LsitingsTab({
  tabs
}) {

  return (
    <ul className='flex space-x-36 border-b-2 mt-8 md:mt-0'>
      {
        map(tabs, item => (
          <Item key={item.value} data={item}>{item.label}</Item>
        ))
      }
    </ul>
  )
}

function Item({
  data,
  children
}) {

  const { tab, changeTab } = useAgentListingsContext()
  const isActive = tab && tab.value === data.value
  function clickHandle() {
    if (tab && tab.value === data.value) return
    changeTab(data)
  }

  return (
    <li className={classNames('cursor-pointer text-font text-base pb-10 border-b-2 border-b-transparent translate-y-2 relative z-[1] md:text-lg', { 'text-primary !border-b-primary': isActive })} onClick={clickHandle}>{children}</li>
  )
}